import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext'; // 引入全域狀態

export default function Member() {
  const navigate = useNavigate();
  // 透過 Context 取得使用者資料與登出功能
  const { user, logout } = useAuth();

  const handleLogout = () => {
    logout(); // 呼叫 Context 的登出 (會自動清空狀態與 LocalStorage)
    navigate('/login'); // 登出後導向回登入頁
  };

  // 因為有 ProtectedRoute 保護，能進來這裡的一定是已登入狀態
  // 我們直接回傳會員中心的 UI 即可，完全刪除重複的登入表單
  return (
    <div className="w-full px-6 md:px-10 py-12 md:py-20">
      <div className="max-w-3xl mx-auto">
        {/* Header */}
        <div className="text-center mb-10">
          <h1 className="text-text-dark text-2xl md:text-3xl font-heading font-bold mb-2">
            會員中心
          </h1>
          <p className="text-text-muted text-sm">管理你的帳號與序號寶庫</p>
        </div>

        {/* Account Info Card */}
        <div className="bg-white rounded-2xl border border-fog-mid p-6 md:p-8 mb-6 shadow-sm">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-full bg-fog border border-fog-mid flex items-center justify-center">
              <i className="ri-user-3-line text-text-dark text-lg"></i>
            </div>
            <h2 className="text-text-dark text-lg font-heading font-semibold">會員帳號</h2>
          </div>

          <div className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-text-dark mb-1.5">Email</label>
              <div className="relative">
                <div className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 flex items-center justify-center">
                  <i className="ri-mail-line text-text-gray text-sm"></i>
                </div>
                {/* 直接顯示從 AuthContext 取得的 user.email */}
                <input
                  type="text"
                  value={user?.email || ''}
                  readOnly
                  className="w-full pl-10 pr-4 py-3 rounded-lg border border-fog-dark bg-fog-gray/30 text-sm text-text-dark outline-none cursor-default"
                />
              </div>
            </div>
          </div>

          <div className="mt-6 pt-5 border-t border-fog-mid">
            <button
              onClick={handleLogout}
              className="text-accent-rose hover:text-accent-rose/80 text-sm font-medium transition-colors cursor-pointer flex items-center gap-1.5"
            >
              <i className="ri-logout-box-r-line text-sm"></i>
              登出帳號
            </button>
          </div>
        </div>

        {/* Key Vault Entry Card */}
        <div className="bg-white rounded-2xl border border-fog-mid p-6 md:p-8 mb-6 shadow-sm">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-full bg-fog border border-fog-mid flex items-center justify-center">
                <i className="ri-key-2-line text-text-dark text-lg"></i>
              </div>
              <h2 className="text-text-dark text-lg font-heading font-semibold">我的序號庫</h2>
            </div>
          </div>
          <p className="text-text-muted text-sm mb-6">
            查看你購買過的所有遊戲序號，一鍵複製功能超方便！
          </p>
          <Link
            to="/key-info"
            className="inline-flex items-center justify-center gap-2 w-full bg-star-black text-white py-3 rounded-lg text-sm font-semibold hover:bg-star-black/90 transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-key-2-line text-xs"></i>
            進入序號庫
          </Link>
        </div>
      </div>
    </div>
  );
}